/* Koffyland — daily recommendation rotation (shared).
   Same pick for every visitor on a given day; rotates at Europe/Paris midnight.
   Progressive enhancement: any failure leaves the server-rendered content untouched.

   Behaviors (opt-in via attributes):
   - [data-kl-daily-grid] + data-collection + data-count
       Swaps the first N `.kl-pcard` children to today's in-stock picks from the collection.
       Optional: data-allow-decaf / data-allow-capsule to permit those categories.
*/
(function () {
  if (window.__klDaily) return; window.__klDaily = 1;
  var euro = function (n) { return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; };

  function klDay() {
    try {
      var s = new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/Paris' }); // YYYY-MM-DD
      var p = s.split('-');
      return Math.floor(Date.UTC(+p[0], +p[1] - 1, +p[2]) / 86400000);
    } catch (e) { return Math.floor(Date.now() / 86400000); }
  }
  function klHash(str) { var h = 2166136261 >>> 0; for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  function klIndex(key, len) { return len > 0 ? klHash(key + '|' + klDay()) % len : 0; }

  function hasTag(p, t) { return (p.tags || []).some(function (x) { return String(x).toLowerCase() === t; }); }
  function isDecaf(p) { return hasTag(p, 'décaf') || hasTag(p, 'decaf') || /d[eé]caf/i.test(p.title || ''); }
  function isCapsule(p) { return hasTag(p, 'capsule') || /capsule|nespresso/i.test(p.title || ''); }

  var cache = {};
  function fetchColl(c) {
    if (!cache[c]) {
      cache[c] = fetch('/collections/' + c + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (d) { return d.products || []; })
        .catch(function () { return []; });
    }
    return cache[c];
  }

  function cheapestVariant(p) {
    var av = (p.variants || []).filter(function (v) { return v.available; });
    av.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
    return av[0] || (p.variants || [])[0];
  }

  function tagSpan(t) { var s = document.createElement('span'); s.className = 'kl-pcard__tag'; s.textContent = t; return s.outerHTML; }

  // Works on both card markups: home `.kl-pcard` and PDP related `.prod-card`.
  function swapCard(card, p) {
    var v = cheapestVariant(p); if (!v) return;
    var url = '/products/' + p.handle;
    var img = (v.featured_image && v.featured_image.src) || (p.images && p.images[0] && p.images[0].src) || '';
    var media = card.querySelector('.kl-pcard__media, .prod-img-wrap');
    if (media) {
      media.setAttribute('href', url);
      media.setAttribute('aria-label', p.title || '');
      var im = media.querySelector('img');
      if (im && img) { im.removeAttribute('srcset'); im.src = img + (img.indexOf('?') > -1 ? '&width=600' : '?width=600'); im.alt = p.title || ''; }
    }
    var brand = card.querySelector('.kl-pcard__brand, .prod-brand'); if (brand) brand.textContent = p.vendor || '';
    var name = card.querySelector('.kl-pcard__name, .prod-name'); if (name) { name.setAttribute('href', url); name.textContent = p.title || ''; }
    card.querySelectorAll('[data-kl-card-link]').forEach(function (link) {
      link.setAttribute('href', url);
      link.setAttribute('aria-label', 'Voir ' + (p.title || 'ce café'));
    });
    var price = card.querySelector('.kl-pcard__price-current, .prod-price'); if (price) price.textContent = euro(parseFloat(v.price));
    var priceUnit = card.querySelector('.kl-pcard__price-unit');
    if (priceUnit) {
      if (v.title && v.title !== 'Default Title') { priceUnit.textContent = '/ ' + v.title; priceUnit.hidden = false; }
      else priceUnit.hidden = true;
    }
    var idInput = card.querySelector('input[name="id"]'); if (idInput) idInput.value = v.id;
    var addBtn = card.querySelector('.kl-pcard__add, .prod-add');
    if (addBtn && addBtn.tagName === 'BUTTON') {
      addBtn.removeAttribute('disabled');
      addBtn.setAttribute('aria-label', addBtn.classList.contains('prod-add') ? 'Ajouter ' + (p.title || '') + ' au panier' : 'Ajouter au panier : ' + (p.title || ''));
    }
    var rating = card.querySelector('.kl-pcard__stars, .prod-stars'); if (rating) rating.hidden = true;
    var tags = card.querySelector('.kl-pcard__tags'); if (tags) tags.innerHTML = (p.tags || []).slice(0, 2).map(tagSpan).join('');
    var status = card.querySelector('[data-kl-pick-status]');
    if (status) status.textContent = (p.variants || []).some(function (variant) { return variant.available; }) ? 'Disponible' : 'Bientôt de retour';
  }

  function runGrid(el) {
    var coll = el.getAttribute('data-collection'); if (!coll) return;
    var count = parseInt(el.getAttribute('data-count') || '4', 10) || 4;
    var allowDecaf = el.hasAttribute('data-allow-decaf');
    var allowCapsule = el.hasAttribute('data-allow-capsule');
    var allowSoldOut = el.hasAttribute('data-allow-sold-out');
    var exclude = el.getAttribute('data-exclude') || '';
    var key = coll + '|' + (el.getAttribute('data-key') || (exclude ? 'rel-' + exclude : 'grid'));
    var cards = Array.prototype.slice.call(el.querySelectorAll('.kl-pcard, .prod-card')).slice(0, count);
    if (!cards.length) return;
    fetchColl(coll).then(function (products) {
      var eligible = products.filter(function (p) {
        return (allowDecaf || !isDecaf(p)) && (allowCapsule || !isCapsule(p)) && p.handle !== exclude;
      });
      var pool = eligible.filter(function (p) {
        return (p.variants || []).some(function (v) { return v.available; });
      });
      if (allowSoldOut && pool.length < count) pool = eligible;
      pool.sort(function (a, b) { return (a.id || 0) - (b.id || 0); });
      if (!pool.length) return;
      var base = klIndex(key, pool.length);
      cards.forEach(function (card, j) { swapCard(card, pool[(base + j) % pool.length]); });
    });
  }

  // [data-kl-daily-window] (+ a larger fetched pool): shows a date-seeded window of N
  // rendered items each day, keeping the platform's relevance ordering. Used on PDP related.
  function runWindow(el) {
    var size = parseInt(el.getAttribute('data-kl-daily-window') || '4', 10) || 4;
    function apply() {
      var items = el.querySelectorAll('.product-grid > .grid__item');
      if (items.length <= size) return false; // not enough to rotate
      var pool = items.length, start = klIndex((location.pathname || '/') + '|window', pool), show = {};
      for (var k = 0; k < size; k++) show[(start + k) % pool] = true;
      for (var i = 0; i < items.length; i++) items[i].style.display = show[i] ? 'block' : 'none';
      return true;
    }
    if (apply()) return;
    var mo = new MutationObserver(function () { if (apply()) mo.disconnect(); });
    mo.observe(el, { childList: true, subtree: true });
    setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 8000);
  }

  // [data-kl-daily-pick] + data-collection: single daily pick, updates elements
  // by data attribute so any card layout can host it. Cleans "A – B – C" titles
  // to the product-name segment. [data-pick-clear] content is removed on swap
  // (server-rendered detail that would be stale for a different product).
  function runPick(el) {
    var coll = el.getAttribute('data-collection'); if (!coll) return;
    var key = coll + '|' + (el.getAttribute('data-key') || 'pick');
    fetchColl(coll).then(function (products) {
      var pool = products.filter(function (p) {
        return (p.variants || []).some(function (v) { return v.available; });
      }).sort(function (a, b) { return (a.id || 0) - (b.id || 0); });
      if (!pool.length) return;
      var p = pool[klIndex(key, pool.length)];
      var v = cheapestVariant(p); if (!v) return;
      var url = '/products/' + p.handle;
      var parts = (p.title || '').split(' – ');
      var shortName = parts.length > 1 ? parts[1] : (p.title || '');
      var img = (v.featured_image && v.featured_image.src) || (p.images && p.images[0] && p.images[0].src) || '';
      el.querySelectorAll('[data-pick-url]').forEach(function (a) { a.setAttribute('href', url); });
      var im = el.querySelector('[data-pick-img]');
      if (im && img) { im.removeAttribute('srcset'); im.src = img + (img.indexOf('?') > -1 ? '&width=200' : '?width=200'); }
      var brand = el.querySelector('[data-pick-brand]'); if (brand) brand.textContent = p.vendor || '';
      var name = el.querySelector('[data-pick-name]'); if (name) name.textContent = shortName;
      var price = el.querySelector('[data-pick-price]'); if (price) price.textContent = euro(parseFloat(v.price));
      el.querySelectorAll('[data-pick-clear]').forEach(function (n) { n.textContent = ''; n.style.display = 'none'; });
    });
  }

  function init() {
    var grids = document.querySelectorAll('[data-kl-daily-grid]');
    for (var i = 0; i < grids.length; i++) runGrid(grids[i]);
    var wins = document.querySelectorAll('[data-kl-daily-window]');
    for (var j = 0; j < wins.length; j++) runWindow(wins[j]);
    var picks = document.querySelectorAll('[data-kl-daily-pick]');
    for (var k = 0; k < picks.length; k++) runPick(picks[k]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
